









import Vue from 'vue';
import Store from '@/services/Store';
import MainArea from '@/components/MainArea.vue';
import ImageArea from '@/components/ImageArea.vue';
import TextArea from '@/components/TextArea.vue';
import { Piano, fId } from '@/services/Utility';

export default Vue.extend({
	name: 'QuizResults',
	mounted() {
		let t = Store.quizState.getQuizTitle().match(/(\w+)/g);
		let title = t !== null ? `__${t[0]}${typeof t[1] !== 'undefined' ? `_${t[1]}` : ''}` : '';
		Piano({t:'page.display', p:{inhaltstyp: title, seitenname_id: 'resultsPage', seitentitel: Store.quizState.getQuizTitle()}});
		window.setTimeout(() => {
			let prms = { status: 200, h: this.$root.$el.clientHeight, tgt: fId };
			// console.log(`QuizResults: will post ${JSON.stringify(prms)}`);
			if (window.self !== window.top) {
				parent.postMessage(prms, 'https://www.br.de');
			}
		}, 500);
	},
	methods: {
		scoreInPercent() {
			return Store.quizState.getScoreInPercent();
		},
		resultTitle() {
			if (this.scoreInPercent() == 100) {
				return '🎉';
			} else if (this.scoreInPercent() > 70) {
				return '👍';
			} else if (this.scoreInPercent() > 30) {
				return '🤔';
			} else {
				return '😱';
			}
		},
		quizResultsSummary() {
			if (this.scoreInPercent() == 100) {
				return Store.quizState.getReportBestText();
			} else if (this.scoreInPercent() > 70) {
				return Store.quizState.getReportGoodText();
			} else if (this.scoreInPercent() > 30) {
				return Store.quizState.getReportBadText();
			} else {
				return Store.quizState.getReportWorstText();
			}
		},
		quizResultsImage() {
			if (this.scoreInPercent() == 100) {
				return Store.quizState.getReportBestImage();
			} else if (this.scoreInPercent() > 70) {
				return Store.quizState.getReportGoodImage();
			} else if (this.scoreInPercent() > 30) {
				return Store.quizState.getReportBadImage();
			} else {
				return Store.quizState.getReportWorstImage();
			}
		},
		handleNextClick() {
			Piano({t:'click.navigation', p:{click:'btnNext', click_chapter1:'navigationButton'}});
			// Pick different quiz
			Store.initRandomPastQuiz().then((newQuiz: any) => {
				// Reset Quiz progress
				this.$root.$data.user = {
					progress: 0,
					score: 0,
					wrongAnswerCount: 0,
					selectedAnswer: '',
				};

				this.$router.push('/');
			});
		},
	},
	beforeRouteEnter(to, from, next) {
		if (to.params.score == undefined) next({ name: 'QuizIntro' });
		else next();
	},
	components: {
		MainArea,
		ImageArea,
		TextArea,
	},
});
